import LinearProgress from "@mui/material/LinearProgress";
import { createDeepEqualSelector } from "components/common/utils";
import { ASSET_STATUS } from "components/fileViewers/logic/actions";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useFileUploadStyles } from "./uploadStyles";

function UploadingImgPreview({ previewUrl, fileId, progress, status, onUploaded }) {
    useEffect(() => {
        if (status === ASSET_STATUS.UPLOADED || status === ASSET_STATUS.FAILED_UPLOAD) {
            onUploaded(fileId, status === ASSET_STATUS.UPLOADED);
        }
    }, [fileId, onUploaded, status]);
    const classes = useFileUploadStyles();
    const canShowbar = progress >= 0 && progress < 100;

    return (
        <div className={classes.container}>
            {canShowbar && (
                <div className={classes.progressContainer}>
                    <LinearProgress variant="determinate" value={progress} color={"secondary"} />
                </div>
            )}

            <img src={previewUrl} alt="" style={{ opacity: canShowbar ? 0.5 : 1 }} />
        </div>
    );
}

const getFileID = (state, props) => props.fileId;
const getFileReducer = () => {
    return createDeepEqualSelector([getFileID, (state) => state.files.assetBatch], (id, assetBatch) => {
        return {
            progress: assetBatch[id] ? assetBatch[id].progress * 100 : 0,
            status: assetBatch[id] ? assetBatch[id].status : null,
        };
    });
};

const makeMapStateToProps = () => {
    const reducer = getFileReducer();
    return (state, props) => {
        return { ...reducer(state, props) };
    };
};

export default connect(makeMapStateToProps)(UploadingImgPreview);
